import { API_URL } from "../api-config";
import { makeApiRequest } from './helpers.js';

export let socket = null;
let onRealtimeCallback = null;

function getWebSocketURL(apiURL) {
    const isSecure = apiURL.startsWith('https://');
    const wsProtocol = isSecure ? 'wss' : 'ws';

    const wsURL = apiURL.replace(/^https?:\/\//, '');
    return `${wsProtocol}://${wsURL}/trading-api/historical/ws`;
}

function connectWebSocket() {
    const websocketURL = getWebSocketURL(API_URL);
    socket = new WebSocket(websocketURL);

    socket.onopen = () => {
        console.log('WebSocket Connected');
        reconnectAttempts = 0;
    };

    socket.onmessage = (event) => {
        const message = JSON.parse(event.data);
    
        // Verifica si el mensaje es un ping y responde con un pong
        if (message.type === 'ping') {
            console.log('Ping recibido del servidor');
            // Envía un mensaje de pong como respuesta
            if (socket.readyState === WebSocket.OPEN) {
                socket.send(JSON.stringify({ type: "pong" }));
                console.log('Pong enviado al servidor');
            }
        } else {
            // Si no es un mensaje de ping, maneja el mensaje como un nuevo tick
            console.log('msg', message)
            handleNewTick(message);
    
            if (typeof window.updateDashboardData === "function") {
                window.updateDashboardData(message);
            }
        }
    };
    

    socket.onerror = (error) => {
        console.error('WebSocket Error:', error);
        scheduleReconnect();  // Asegúrate de intentar reconectar después de un error
    };
    
    socket.onclose = (event) => {
        console.log('WebSocket Disconnected', event);
        scheduleReconnect();  // Intenta reconectar después de una desconexión
    };    
}

let reconnectAttempts = 0;

function scheduleReconnect() {
    console.log('Trying to Reconnect Websocket')
    setTimeout(() => {
        if (reconnectAttempts < 8) {  // Limita el número de intentos
            connectWebSocket();
            reconnectAttempts++;
        }
    }, Math.pow(2, reconnectAttempts) * 1000);  // Backoff exponencial
}


window.onbeforeunload = () => {
    window.isUnloading = true;
    console.log('onbeforeunload');
    closeWebSocket();
};


function handleNewTick(tickData) {
    if (tickData && tickData.datetime && tickData.price && tickData.volume) {
        const time = new Date(tickData.datetime).getTime();
        const formattedTick = {
            time: time,
            low: tickData.price,
            high: tickData.price,
            open: tickData.price,
            close: tickData.price,
            volume: tickData.volume
        };
        if (onRealtimeCallback) {
            onRealtimeCallback(formattedTick);
        }
    } else {
        console.error('Formato de tick incorrecto:', tickData);
    }
}

export function closeWebSocket() {
    console.log('closeWebSocket');
    if (socket) {
        socket.close();
        socket = null;
    }
}

export function setRealtimeCallback(callback) {
    onRealtimeCallback = callback;
}

class fakeTick {
    constructor(datetime, price, volume) {
        this.datetime = datetime;
        this.price = price;
        this.volume = volume;
    }
}

export function generateFakeTicks(candle) {
    const now = new Date().toLocaleString('en-US', { timeZone: 'America/Santiago' });
    const fake_tick = new fakeTick(now, Math.random() * (candle.high - candle.low) + candle.low, (Math.random() * (800 - 300) + 300) * 1000)
    handleNewTick(fake_tick);
}

export async function runSimulation() {
    const data = await makeApiRequest(`${API_URL}/daily_candles`);
    const candle = data[0];
    generateFakeTicks(candle);
    setInterval( function (){
        generateFakeTicks(candle);
    }, 2000)
}

export default connectWebSocket;